/**
 * What: Merchant-facing copy for selecting and permanently deleting saved tests.
 * Transport / data-flow: Pure strings and count formatters merged into the Shopify component copy catalog.
 */
export const shopifyComponentBulkDeleteCopy = {
    studySetupBulkDeleteDialog: {
        titleSingular: 'Delete this test?',
        titlePlural: (count) => `Delete ${count} tests?`,
        retryTitleSingular: 'Retry deleting this test?',
        retryTitlePlural: (count) => `Retry deleting ${count} tests?`,
        statusSingular: 'Deletion status for test',
        statusPlural: (count) => `Deletion status for ${count} tests`,
        noSelectionTitle: 'No tests selected',
        runningSingular: 'Deleting test',
        runningPlural: (count) => `Deleting ${count} tests`,
        checkingSingular: 'Checking deletion status',
        checkingPlural: (count) => `Checking deletion status for ${count} tests`,
        confirmSingular: 'Delete test',
        confirmPlural: (count) => `Delete ${count} tests`,
        closeProgress: 'Close',
        cancel: 'Cancel',
        permanentRemoval: 'This permanently removes the selected tests and their test data. You can’t undo this. Credit receipts are kept, and eligible failed tests receive their credits back automatically.',
        continuedInBackground: 'Deletion continues if you close this window.',
        productUnavailable: 'Product unavailable',
        deleted: 'Deleted',
        deleting: 'Deletion in progress',
        failed: 'Could not delete',
        testDeletedToast: 'Test deleted',
        testsDeletedToast: (count) => `${count} tests deleted`,
        retryFailed: 'Retry failed tests',
        checkPending: 'Check deletion status',
        confirmCheck: 'Check deletion status',
        confirmRetry: 'Retry failed tests',
        confirmContinue: 'Continue',
        outcomeSummary: (completed, pending, failed) => `Deleted: ${completed}. In progress: ${pending}. Needs retry: ${failed}.`,
        eligibilityChanged: 'Some selected tests are no longer available to delete. Review the updated list and confirm again.',
        partialFailure: 'Some tests could not be deleted. Retry the failed tests.',
        failure: 'The selected tests could not be deleted. Try again.',
        previousFailure: 'The previous deletion did not finish. Retry the failed test to try again.',
        deletionFailure: 'The test could not be deleted. Try again.',
        statusUnavailable: 'Deletion status is unavailable.',
        selectAllEligible: (plural, count) => `Select all eligible ${plural} on this page (${count})`,
        selectedCount: (count) => `${count} selected`,
        clearSelection: 'Clear selection',
        deleteSelected: (plural) => `Delete ${plural}`,
        selectItem: (title) => `Select ${title}`,
        selectedTestsList: 'Tests selected for deletion',
    },
};
//# sourceMappingURL=bulk-delete.js.map